export default [
  {
    path: "/tasksControl/add/:id",
    name: "tasksControlAdd",
    meta: {
      is_headless: true,
      name: "Конструктор заданий",
      access: [
        "admin"
      ]
    },
    component: () => import("@/views/viewTasks/ViewTasksControlAdd.vue")
  },
  {
    path: "/tasksControl/edit/:id",
    name: "tasksControlEdit",
    meta: {
      is_headless: true,
      name: "Редактирование задания",
      access: ["admin"]
    },
    component: () => import("@/views/viewTasks/ViewTasksControlEdit.vue")
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404"
  },
  {
    path: "/banners/add",
    name: "bannersConstructorAdd",
    meta: {
      is_headless: true,
      name: "Баннер",
      access: ["admin"]
    },
    component: () => import("@/views/viewBanners/ViewBannersConstructorAdd.vue")
  },
  {
    path: "/banners/edit/:id",
    name: "bannersConstructorEdit",
    meta: {
      is_headless: true,
      name: "Баннер",
      access: ["admin"]
    },
    component: () => import("@/views/viewBanners/ViewBannersConstructorEdit.vue")
  },
  {
    path: "/competitions/add",
    name: "competitionsAdd",
    meta: {
      is_headless: true,
      name: "Соревнование",
      access: ["admin"]
    },
    component: () => import("@/views/viewCompetitions/ViewCompetitionsAdd.vue")
  },
  {
    path: "/competitions/edit/:id",
    name: "competitionsEdit",
    meta: {
      is_headless: true,
      name: "Редактирование соревнования",
      access: ["admin"]
    },
    component: () => import("@/views/viewCompetitions/ViewCompetitionsEdit.vue")
  },
]